import site from '@src/state/site/site'
import siteConfig from '@src/state/site/siteConfig'
import { LOCAL_OR_PLAYGROUND } from '@src/utils/localOrPlayground'
import { useEffect } from 'react'

declare global {
  interface Window {
    whoAmI: () => string
  }
}

export function useSetVersion() {
  useEffect(() => {
    window.whoAmI = () => siteConfig(site, LOCAL_OR_PLAYGROUND).wfeReleaseTag
  }, [])
}



// WEBPACK FOOTER //
// ./src/utils/hooks/useSetVersion.ts